import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import update from 'immutability-helper';

import CommentsArea from '../comments/CommentsArea.js';
import TagEditorContainer from '../tags/TagEditorContainer.js';
import TagsList from '../tags/TagsList.js';

class ArticlePageControls extends React.Component {
  constructor(props) {
    super(props);
    const {article, liked} = props;

    this.state = {
      editingTags: false,
      liked: liked || false,
      likes: article.likes_cache,
      tags: null,
    };
  }

  componentDidMount() {
    this._loadTags();
  }

  _removeTag = (tag) => {
    if (!this.state.tags || !tag.removable) {
      return;
    }
    if (!confirm('Are you sure?')) {
      return;
    }
    $.deleteJSON(this.props.article._links.tags.href, {user_id: tag.user_id, child_id: tag.child_id, team_member_id: tag.team_member_id}).then(data => {
      const i = this.state.tags.tags.indexOf(tag);
      if (i < 0) {
        return;
      }
      this.setState(update(this.state, {
        tags: {
          tags: {
            $splice: [[i, 1]],
          },
        },
      }));
    });
  };

  _editTags = () => {
    if (this.state.editingTags) {
      this.setState({editingTags: false}, this._loadTags);
      return;
    }
    this.setState({editingTags: true});
  };

  _like = () => {
    if (!this.props.article._links.like) {
      return;
    }
    if (this.state.liked) {
      $.postJSON(this.props.article._links.unlike.href).done(data => {
        this.setState({
          liked: false,
          likes: data.likes_cache,
        });
      });
      return;
    }
    $.postJSON(this.props.article._links.like.href).done(data => {
      this.setState({
        liked: true,
        likes: data.likes_cache,
      });
    });
  };

  _loadTags = () => {
    const {article} = this.props;
    $.getJSON(article._links.tags.href).done(data => {
      this.setState({tags: data});
    });
  };

  render() {
    const {article} = this.props;
    let tagsArea = null;
    if (!this.state.tags) {
      // do nothing
    } else if (this.state.editingTags) {
      tagsArea = (
        <TagEditorContainer {...this.state.tags} />
      );
    } else {
      tagsArea = (
        <TagsList data={this.state.tags} onRemove={this._removeTag} />
      );
    }
    return (
      <div>
        {tagsArea}
        <div className="btn-group btn-group-justified">
          <div className="btn-group">
            <button className="btn btn-default" disabled={!this.state.tags || !this.state.tags.editable} onClick={this._editTags}>
              <i className="fa fa-tags"></i> Tag
            </button>
          </div>
          <div className="btn-group">
            {
              article._links.share ? (
                <a className="btn btn-default" href={article._links.share.href}>
                  <i className="fa fa-share-alt-square"></i> Share
                </a>
              ): (
                <button className="btn btn-default"></button>
              )
            }
          </div>
          <div className="btn-group">
            <button className="btn btn-default" onClick={this._like}>
              <i className={cx('fa', 'fa-arrow-up', {'color-liked': this.state.liked})}></i> {this.state.likes}
            </button>
          </div>
        </div>
        {
          article._links.comments ? (
            <CommentsArea source={article._links.comments.href} />
          ): null
        }
      </div>
    );
  }
}

export default ArticlePageControls;
